// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.checkout {
  background-color: #fff;
}

.panel {
  background-color: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
}

.form-control {
  border: 1px solid #e2e2e2;
}

#form-checkout .has-error input {
  border-color: #e57373;
}
#form-checkout .has-error input:focus, #form-checkout .has-error input:hover {
  border: 1px solid #e57373;
}

.form-control.error {
  border: 1px solid #e57373;
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
/*  alterações novas  */
.panel-body-altera {
  text-align: right;
}

.panel-body-altera .btn-confirmar {
  margin-bottom: 5px;
}

.panel-body-altera .cartoes-cadastrados {
  padding-bottom: 80px;
  padding-top: 10px;
}

.panel-body-altera .cartoes-cadastrados .cartao {
  padding: 10px;
  border: 2px solid #00caff;
  border-radius: 5px;
  background-color: #fff;
  text-align: left;
  height: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  color: hsl(0, 0%, 30%);
  font-size: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.5s ease-out;
}

.panel-body-altera .cartoes-cadastrados .cartao.disabled {
  background-color: #fcfcfc;
  border: 2px solid rgba(216, 216, 216, 0.5);
  color: #8b8b8b;
  transition: background-color 0.5s ease, border-color 0.5s ease;
}

.panel-body-altera .cartoes-cadastrados .cartao.disabled:hover {
  background-color: #fff;
  border-color: rgb(216, 216, 216);
}

.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao {
  background-color: #fcfcfc;
  border: 2px solid rgba(216, 216, 216, 0.5);
  color: #4379ff;
  font-family: "Pague.la", "Open Sans", sans-serif;
  font-size: 15px;
  font-weight: bolder;
  padding-left: 30px;
  transition: background-color 0.5s ease, border-color 0.5s ease;
}

.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao:hover {
  background-color: #fff;
  border-color: rgb(216, 216, 216);
}

.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao span > span {
  font-size: 19px;
  line-height: 1;
}

.panel-body-altera .cartoes-cadastrados .cartao .bandeira-cartao {
  margin: 0;
  display: inline-block;
  vertical-align: middle;
  height: 26px;
  width: 66px;
}

.panel-body-altera .cartoes-cadastrados .cartao .editar-cartao-button {
  width: 7px;
  height: 19px;
  display: inline-block;
  background-image: url(/assets/icones/menu-edit.svg);
  background-repeat: no-repeat;
  padding: 10px;
  background-position: center;
}

.panel-body-altera .cartoes-cadastrados .cartao .final-pan strong,
.cartoes-cadastrados .cartao .validade-cartao strong {
  font-family: pague-la, "Open Sans", sans-serif;
  font-size: 15px;
}

.remover-dom {
  visibility: hidden;
  opacity: 0;
  display: none;
}

.flex {
  display: flex;
}

.space-between {
  justify-content: space-between;
  align-items: center;
}

h5 {
  color: #4d4d4d;
  font-size: 14px;
  line-height: inherit;
}

.info-venda .venda:last-child {
  margin-bottom: 20px;
}

.venda .valores {
  margin-bottom: 5px;
}

.venda .data-entrada {
  font-size: 12px;
  text-align: right;
}

.venda .data-entrada .valor-data {
  font-family: pague-la, "Open Sans", sans-serif;
  font-weight: bolder;
  font-size: 13px;
}

.venda .valor-entrada {
  display: block;
  font-family: pague-la, "Open Sans", sans-serif;
  font-weight: bolder;
  font-size: 13px;
  text-align: right;
}

/* #cartoes-cadastrados, #form-checkout {
    transition: opacity 0.5s ease;
} */
@media (min-width: 768px) {
  .checkout .cls-content .cls-content-lg {
    width: 700px;
  }
}
.menu-remove {
  background-color: #FFF;
  width: 100px;
  height: 35px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: 7px;
  text-align: center;
  border-radius: 0.25rem;
  position: relative;
  top: 12px;
  left: -78px;
}

.menu-remove:hover {
  background-color: #EFEFEF;
}

@media (min-width: 768px) {
  .checkout .cls-content .cls-content-lg {
    width: 700px;
  }
}
.checkout.cls-container {
  background-color: #FFFFFF;
}

.checkout .cls-content {
  padding-top: 5vh;
}

.checkout .rodape {
  margin-top: 30px;
}

.checkout .rodape p {
  margin-right: auto;
  margin-left: auto;
}

.checkout .panel-content {
  display: flex;
}

.checkout p,
.checkout h4,
.checkout h5 {
  display: table;
}

.mb-clean {
  margin-bottom: 0;
}

.checkout .panel-body1 {
  width: 35%;
  background-color: #fff;
  padding: 20px 40px 25px;
  border-bottom-left-radius: 10px;
}

.checkout .panel-body1 .total {
  font-size: 18px;
  font-family: "Pague.la", "Open Sans", sans-serif;
}

.checkout .panel-body1 p {
  color: #999999;
  margin-bottom: 8px;
}

.checkout .panel-body1 h4 {
  color: #4379ff;
  font-family: "Pague.la", "Open Sans", sans-serif;
  font-size: 25px;
  font-weight: 900;
  margin-top: 0;
}

.checkout .texto-destaque {
  color: #4379ff;
  font-family: "Pague.la", "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 900;
  margin-top: 0;
}

.checkout .panel-body1 h5 {
  margin-top: 15px;
}

.checkout .panel-body2 {
  width: 65%;
  background-color: #fcfcfc;
  padding: 20px 40px 35px;
}

@media (min-width: 768px) {
  .checkout .cartao-credito {
    width: 100%;
  }
}
.checkout .form-control {
  font-size: 15px;
  font-weight: bolder;
}

input:-moz-placeholder,
input::-webkit-input-placeholder,
input:-ms-input-placeholder {
  color: red;
}

.checkout .panel {
  border-radius: 10px;
}

.checkout .panel-heading {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 80px;
  border-bottom: none;
}

.pagamento-seguro {
  text-align: right;
  position: absolute;
  right: 40px;
  top: 20px;
  color: #ffffff;
}

.pagamento-seguro p {
  display: inline-block;
}

.pagamento-seguro p strong {
  display: block;
}

.checkout .panel-heading:after {
  border-bottom: none;
}

.checkout .logo-paguela-cinza {
  margin-bottom: 30px;
}

.checkout .logo-paguela-cinza svg {
  height: 30px;
}

.checkout .panel-heading h3 {
  color: #fff;
  letter-spacing: 1px;
  text-align: left;
  font-size: 25px;
  padding-top: 15px;
  padding-left: 40px;
  font-family: "Pague.la", "Open Sans", sans-serif;
  font-weight: 100;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  cursor: default;
}

z .checkout label,
.registro .pad-all {
  color: #999999;
}

.checkout input,
.registro select {
  border-radius: 4px;
  border-color: #d9d9d9;
}

.checkout input:focus {
  border-color: #00CAFF;
}

.checkout .panel-heading {
  background: rgb(0, 204, 255);
  background: -webkit-gradient(left bottom, right top, color-stop(0%, rgb(0, 204, 255)), color-stop(70%, rgb(161, 80, 253)), color-stop(100%, rgb(177, 54, 253)));
  background: linear-gradient(15deg, rgb(0, 204, 255) 0%, rgb(161, 80, 253) 70%, rgb(177, 54, 253) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#00ccff", endColorstr="#b136fd", GradientType=1);
}

.mt-20 {
  margin-top: 20px;
}

.btn-registrar,
.btn-primary {
  position: absolute;
  bottom: 40px;
  right: 40px;
  font-family: "Pague.la", "Open Sans", sans-serif;
  color: #fff;
  font-size: 1.8rem;
  padding: 7.5px 27px;
  border-radius: 5px;
  letter-spacing: 0.8px;
  background: #22b5ff;
  background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));
  background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#22b5ff", endColorstr="#a42cff", GradientType=1);
  border: none;
  float: right;
}

.btn-registrar:active,
.btn-primary:active,
.btn-registrar:hover,
.btn-primary:hover,
.btn-registrar:focus .btn-primary:focus {
  color: #fff;
  background: #22b5ff;
  background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));
  background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#22b5ff", endColorstr="#a42cff", GradientType=1);
}

#reinicia-venda {
  float: none;
}

.cadeado {
  max-width: 35px;
  display: inline-block;
  position: relative;
  top: 2px;
}

.cadeado svg {
  height: 30px;
}

#cartao-error {
  margin-bottom: 0 !important;
}

.checkout .form-group {
  margin-bottom: 15px;
}

.checkout .form-group .control-label {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

img.logo-cliente {
  max-width: 165px;
  max-height: 117px;
  margin: 10px auto;
}

.bandeira-cartao {
  width: 50px;
  height: 27px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  margin: 7px 0 0 0;
  opacity: 0;
  transition: opacity 0.5s ease;
  right: 8px;
  top: 3px;
}

.checkout .has-feedback label ~ .form-control-feedback {
  top: 27px;
  right: 10px;
}

.master,
.visa,
.elo,
.diners,
.aura,
.jcb,
.hipercard,
.american-express {
  opacity: 1;
}

.default {
  opacity: 0;
}

.master {
  background-image: url("/assets/icones/mastercard.svg");
}

.hipercard {
  background-image: url("/assets/icones/hipercard.png");
}

.visa {
  background-image: url("/assets/icones/visa.svg");
}

.american-express {
  background-image: url("/assets/icones/american-express.svg");
}

.diners {
  background-image: url("/assets/icones/diners.svg");
}

.discover {
  background-image: url("/assets/icones/discover.svg");
}

.elo {
  background-image: url("/assets/icones/elo.svg");
}

.jcb {
  background-image: url("/assets/icones/jbc.png");
}

@media only screen and (min-resolution: 1.5dppx), (min-resolution: 144dpi) {
  .jcb {
    background-image: url("/assets/icones/jbc@2x.png");
  }
}
.aura {
  background-image: url("/assets/icones/aura.png");
}

@media only screen and (min-resolution: 1.5dppx), (min-resolution: 144dpi) {
  .aura {
    background-image: url("/assets/icones/aura@2x.png");
  }
}
.btn.loading {
  color: transparent;
  height: 35px;
  width: 35px;
  padding: 0;
  border-radius: 50%;
  animation: loadBotao 0.25s ease, spin 0.75s linear infinite 0.25s;
}

.btn.loading:before {
  content: "";
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background-color: #fcfcfc;
  position: relative;
  display: block;
  margin: 1px;
}

@keyframes loadBotao {
  from {
    height: initial;
    width: initial;
  }
  to {
    height: 35px;
    width: 35px;
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
#nometitular-error {
  margin-bottom: 40px;
}

#nometitular-error,
#cartao-error {
  color: #eb2521;
}

@media (max-width: 767px) {
  .checkout .panel-heading h3 {
    padding-left: 20px;
  }
  .checkout .cls-content {
    padding: 0;
  }
  .checkout .cls-content .cls-content-lg {
    width: 100%;
    box-shadow: none;
  }
  .checkout .panel-content {
    display: block;
  }
  .logo-cliente {
    display: block !important;
  }
  .info-loja * {
    display: block !important;
  }
  .panel-body2,
  .panel-body1 {
    width: 100% !important;
    text-align: center;
    padding: 20px !important;
  }
  .pagamento-seguro {
    right: 20px;
  }
  .info-pagamento {
    display: flex;
    justify-content: space-between;
  }
  #nometitular {
    margin-bottom: 100px;
  }
  .checkout .panel-heading {
    border-radius: 0;
  }
  /* .checkout .panel-heading h3 {
    position: relative;
    text-align: center;
    padding: 15px 0 0;
  }
  .pagamento-seguro {
    position: relative;
    text-align: center;
    top: 0;
    right: 0;
  }
  .pagamento-seguro p {
    text-align: right;
  } */
  .checkout .panel-body1 p.totais {
    position: absolute;
    float: left;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .checkout .form-group [for=validadeano].control-label {
    display: none;
  }
}
#resultado-sucesso h3 {
  display: block;
  color: #00caff;
  font-family: "Pague.la", "Open Sans", sans-serif;
  margin-top: 8px;
}

#resultado-reprovado h3 {
  display: block;
  color: #e95753;
  margin-top: 8px;
  font-family: "Pague.la", "Open Sans", sans-serif;
}

/*altura SVGS de validação*/
#resultado-sucesso svg,
#resultado-reprovado svg {
  height: 75px;
}

/*animação círculos svgs*/
#resultado-sucesso svg circle,
#resultado-reprovado svg circle {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 2.5s ease forwards;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
/* animação somente de sucesso */
#resultado-sucesso svg polyline {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 3.5s ease forwards;
  animation-delay: 0.25s;
}

#resultado-reprovado svg .linha-1 {
  transform: translate(20px, -20px);
  opacity: 0;
  animation: entrando 0.25s ease-in forwards;
  animation-delay: 0.3s;
}

#resultado-reprovado svg .linha-2 {
  transform: translate(-20px, -20px);
  opacity: 0;
  animation: entrando 0.25s ease-in forwards;
  animation-delay: 0.4s;
}

@keyframes entrando {
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
/* animação reprovado */
#resultado-reprovado svg {
  animation: shake-reprovado 0.35s ease forwards;
  animation-delay: 0.6s;
}

@keyframes shake-reprovado {
  10%, 90% {
    transform: translate3d(0, -1px, 0);
  }
  20%, 80% {
    transform: translate3d(0, 2px, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(0, -4px, 0);
  }
  40%, 60% {
    transform: translate3d(0, 4px, 0);
  }
}
#resultado-sucesso .bandeira-cartao {
  position: absolute;
  top: -5px;
  right: 0px;
}

#resultado-sucesso .info-cartao {
  position: relative;
  padding-right: 75px;
}

#resultado-sucesso .fechar {
  margin-top: 40px;
}

#resultado-sucesso .info-transacao-aprovada {
  margin-top: 20px;
}

#resultado-sucesso .info-transacao-aprovada hr {
  margin: 10px 0 !important;
}

#resultado-sucesso .dados-aprovados {
  display: flex;
  justify-content: space-between;
}

.margin-auto {
  margin: 0 auto;
}

.mb-30 {
  margin-bottom: 30px !important;
}

.mt-30 {
  margin-top: 30px !important;
}

/* página 404 */
.pagina-404 #container {
  background: rgb(0, 247, 255);
  background: -webkit-gradient(left bottom, right top, color-stop(0%, rgb(0, 247, 255)), color-stop(75%, rgb(170, 0, 255)), color-stop(100%, rgb(170, 0, 255)));
  background: linear-gradient(45deg, rgb(0, 247, 255) 0%, rgb(170, 0, 255) 75%, rgb(170, 0, 255) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#00f7ff", endColorstr="#aa00ff", GradientType=1);
}

.pagina-404 .btn-confirmar {
  position: initial;
}

.pagina-404 .text-main {
  font-family: pague-la, "open sans", sans-serif;
  font-size: 2rem;
}

h1.error-code {
  font-family: pague-la, "open sans", sans-serif;
  color: #fff;
}

.checkout-table {
  width: 100%;
  margin: 20px 0;
}
.checkout-table tbody tr td {
  color: #777777;
  border-bottom: 1px solid #cccccc;
  padding: 10px 0 5px;
}

.scheduled-transations {
  margin-top: 40px;
}

.modal-checkout {
  z-index: 10;
  width: 100vw;
  height: 100vh;
  position: fixed;
  display: none;
  top: 0;
  left: 0;
  background-color: rgba(18, 0, 64, 0.85);
  font-family: "Pague.la", "Open Sans", sans-serif;
}
.modal-checkout.modal-checkout-show {
  display: block;
  animation-name: fade;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}
.modal-checkout.modal-checkout-show .icon {
  animation-name: fade;
  animation-delay: 0.2s;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}
.modal-checkout.modal-checkout-show span:first-child {
  animation-name: fade;
  animation-delay: 0.4s;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}
.modal-checkout.modal-checkout-show span:last-child {
  animation-name: fade;
  animation-delay: 0.6s;
  animation-duration: 0.8s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}
.modal-checkout.modal-checkout-show button {
  animation-name: fade;
  animation-delay: 0.8s;
  animation-duration: 1.1s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}
.modal-checkout div:first-child {
  position: relative;
  top: 30%;
}
.modal-checkout span {
  opacity: 0;
  width: 100%;
  display: inline-block;
}
.modal-checkout .icon {
  opacity: 0;
  width: 60px;
  margin: 0 auto;
}
.modal-checkout .icon img {
  width: 100%;
  margin: 20px 0;
}
.modal-checkout .text {
  color: #fff;
  font-size: 36px;
}
.modal-checkout .button {
  position: relative;
  top: 120px;
  left: 40px;
  right: 0;
  width: 200px;
  margin: 0 auto;
  transition: 0.5s;
}
.modal-checkout .button button {
  opacity: 0;
  width: 200px;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/checkout2/components/checkout2/checkout2.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,sBCsBM;ADtBR;;AAGA;EACE,sBCkBM;EDjBN,wCAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,qBCkBO;ADlBT;AACE;EACE,yBAAA;AACJ;;AAGA;EACI,yBAAA;EACA,gEAAA;EACA,+BAAA;EACA,2BAAA;EACA,mBAAA;AAAJ;;AAGA;EACE;IAEE,kCAAA;EADF;EAGA;IAEE,iCAAA;EAFF;EAIA;IAGE,kCAAA;EAJF;EAMA;IAEE,iCAAA;EALF;AACF;AAQA,uBAAA;AAEA;EACE,iBAAA;AAPF;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACI,oBAAA;EACA,iBAAA;AAPJ;;AAUA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;AAPF;;AAUA;EACE,yBAAA;EACA,0CAAA;EACA,cAAA;EACA,8DAAA;AAPF;;AAUA;EACE,sBAAA;EACA,gCAAA;AAPF;;AAUA;EACE,yBAAA;EACA,0CAAA;EAEA,cAAA;EACA,gDC5De;ED6Df,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,8DAAA;AARF;;AAWA;EACE,sBAAA;EACA,gCAAA;AARF;;AAWA;EACE,eAAA;EACA,cAAA;AARF;;AAWA;EACE,SAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AARF;;AAWA;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,mDAAA;EACA,4BAAA;EACA,aAAA;EACA,2BAAA;AARF;;AAWA;;EAEE,8CAAA;EACA,eAAA;AARF;;AAWA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;AARF;;AAWA;EACE,aAAA;AARF;;AAWA;EACE,8BAAA;EACA,mBAAA;AARF;;AAWA;EACE,cAAA;EACA,eAAA;EACA,oBAAA;AARF;;AAWA;EACI,mBAAA;AARJ;;AAWA;EACI,kBAAA;AARJ;;AAWA;EACI,eAAA;EACA,iBAAA;AARJ;;AAWA;EACI,8CAAA;EACA,mBAAA;EACA,eAAA;AARJ;;AAWA;EACE,cAAA;EACA,8CAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AARF;;AAWA;;GAAA;AAIA;EACE;IACE,YAAA;EATF;AACF;AAYA;EACE,sBAAA;EACA,YAAA;EACA,YAAA;EACA,qCAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAVF;;AAaA;EACE,yBAAA;AAVF;;AAaA;EACE;IACE,YAAA;EAVF;AACF;AAqBA;EACE,yBAAA;AAnBF;;AAsBA;EACE,gBAAA;AAnBF;;AAsBA;EACE,gBAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE,aAAA;AAnBF;;AAsBA;;;EAGE,cAAA;AAnBF;;AAsBA;EACE,gBAAA;AAnBF;;AAsBA;EACE,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,gDCtOe;ADmNjB;;AAsBA;EACE,cAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,gDChPe;EDiPf,eAAA;EACA,gBAAA;EACA,aAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,gDCxPe;EDyPf,eAAA;EACA,gBAAA;EACA,aAAA;AAnBF;;AAsBA;EACE,gBAAA;AAnBF;;AAsBA;EACE,UAAA;EACA,yBAAA;EACA,uBAAA;AAnBF;;AAsBA;EACE;IACE,WAAA;EAnBF;AACF;AAsBA;EACE,eAAA;EACA,mBAAA;AApBF;;AAuBA;;;EAGE,UAAA;AApBF;;AAuBA;EACE,mBAAA;AApBF;;AAuBA;EACE,4BAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;AApBF;;AAuBA;EACE,qBAAA;AApBF;;AAuBA;EACE,cAAA;AApBF;;AAuBA;EACE,mBAAA;AApBF;;AAuBA;EACE,mBAAA;AApBF;;AAuBA;EACE,YAAA;AApBF;;AAuBA;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gDCvUe;EDwUf,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AApBF;;AAuBA;;EAEE,cAAA;AApBF;;AAuBA;;EAEE,kBAAA;EACA,qBAAA;AApBF;;AAuBA;EACE,qBAAA;AApBF;;AAuBA;EACE,4BAAA;EAEA,+JAAA;EAIA,sGAAA;EACA,mHAAA;AApBF;;AAuBA;EACE,gBAAA;AApBF;;AAuBA;;EAEI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gDCnXa;EDoXb,WCnYI;EDoYJ,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EAEA,sLAAA;EAIA,mGAAA;EACA,mHAAA;EACA,YAAA;EACA,YAAA;AApBJ;;AAuBA;;;;;EAKI,WAAA;EACA,mBAAA;EAEA,sLAAA;EAIA,mGAAA;EACA,mHAAA;AApBJ;;AAuBA;EACE,WAAA;AApBF;;AAuBA;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;AApBF;;AAuBA;EACE,YAAA;AApBF;;AAuBA;EACE,2BAAA;AApBF;;AAuBA;EACE,mBAAA;AApBF;;AAuBA;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;AApBF;;AAuBA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;AApBF;;AAuBA;EACE,WAAA;EACE,YAAA;EACA,0BAAA;EACA,4BAAA;EACA,iBAAA;EACA,UAAA;EAEA,6BAAA;EACA,UAAA;EACA,QAAA;AApBJ;;AAuBA;EACE,SAAA;EACA,WAAA;AApBF;;AAuBA;;;;;;;;EAQE,UAAA;AApBF;;AAuBA;EACE,UAAA;AApBF;;AAuBA;EACE,sDAAA;AApBF;;AAuBA;EACE,qDAAA;AApBF;;AAuBA;EACE,gDAAA;AApBF;;AAuBA;EACE,4DAAA;AApBF;;AAuBA;EACE,kDAAA;AApBF;;AAuBA;EACE,oDAAA;AApBF;;AAuBA;EACE,+CAAA;AApBF;;AAuBA;EACE,+CAAA;AApBF;;AAuBA;EAIE;IACE,kDAAA;EAvBF;AACF;AA0BA;EACE,gDAAA;AAxBF;;AA2BA;EAIE;IACE,mDAAA;EA3BF;AACF;AA8BA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,iEAAA;AA5BF;;AA+BA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AA5BF;;AA+BA;EACE;IACE,eAAA;IACA,cAAA;EA5BF;EA8BA;IACE,YAAA;IACA,WAAA;EA5BF;AACF;AA+BA;EACE;IACE,uBAAA;EA7BF;EA+BA;IACE,yBAAA;EA7BF;AACF;AAgCA;EACE,mBAAA;AA9BF;;AAiCA;;EAEE,cAAA;AA9BF;;AAiCA;EACE;IACE,kBAAA;EA9BF;EAiCA;IACE,UAAA;EA/BF;EAkCA;IACE,WAAA;IACA,gBAAA;EAhCF;EAmCA;IACE,cAAA;EAjCF;EAmCA;IACE,yBAAA;EAjCF;EAmCA;IACE,yBAAA;EAjCF;EAmCA;;IAEE,sBAAA;IACA,kBAAA;IACA,wBAAA;EAjCF;EAmCA;IACE,WAAA;EAjCF;EAmCA;IACE,aAAA;IACA,8BAAA;EAjCF;EAmCA;IACE,oBAAA;EAjCF;EAmCA;IACE,gBAAA;EAjCF;EAmCA;;;;;;;;;;;;;KAAA;EAcA;IACE,kBAAA;IACA,WAAA;IACA,SAAA;IACA,6BAAA;EAjCF;EAmCA;IACE,aAAA;EAjCF;AACF;AAoCA;EACE,cAAA;EACA,cAAA;EACA,gDCvoBe;EDwoBf,eAAA;AAlCF;;AAqCA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gDC/oBe;AD6mBjB;;AAqCA,2BAAA;AAEA;;EAEE,YAAA;AAnCF;;AAsCA,yBAAA;AAEA;;EAEE,sBAAA;EACA,uBAAA;EACA,kCAAA;AApCF;;AAuCA;EACE;IACE,oBAAA;EApCF;AACF;AAuCA,gCAAA;AAEA;EACE,sBAAA;EACA,uBAAA;EACA,kCAAA;EACA,sBAAA;AAtCF;;AAyCA;EACE,iCAAA;EACA,UAAA;EACA,0CAAA;EACA,qBAAA;AAtCF;;AAyCA;EACE,kCAAA;EACA,UAAA;EACA,0CAAA;EACA,qBAAA;AAtCF;;AAyCA;EACE;IACE,8BAAA;IACA,UAAA;EAtCF;AACF;AAyCA,uBAAA;AAEA;EACE,8CAAA;EACA,qBAAA;AAxCF;;AA2CA;EACE;IAEE,kCAAA;EAzCF;EA2CA;IAEE,iCAAA;EA1CF;EA4CA;IAGE,kCAAA;EA5CF;EA8CA;IAEE,iCAAA;EA7CF;AACF;AAgDA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AA9CF;;AAiDA;EACE,kBAAA;EACA,mBAAA;AA9CF;;AAiDA;EACE,gBAAA;AA9CF;;AAiDA;EACE,gBAAA;AA9CF;;AAiDA;EACE,yBAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,8BAAA;AA9CF;;AAiDA;EACE,cAAA;AA9CF;;AAiDA;EACE,8BAAA;AA9CF;;AAiDA;EACE,2BAAA;AA9CF;;AAiDA,eAAA;AAEA;EACE,4BAAA;EAEA,6JAAA;EAIA,oGAAA;EACA,mHAAA;AA/CF;;AAkDA;EACE,iBAAA;AA/CF;;AAkDA;EACE,8CAAA;EACA,eAAA;AA/CF;;AAkDA;EACE,8CAAA;EACA,WAAA;AA/CF;;AAkDA;EACE,WAAA;EACA,cAAA;AA/CF;AAkDM;EACE,cCj0BI;EDk0BJ,gCAAA;EACA,mBAAA;AAhDR;;AAsDA;EACE,gBAAA;AAnDF;;AAsDA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,gDC/zBe;AD4wBjB;AAoDE;EACE,cAAA;EACA,oBAAA;EACA,wBAAA;EACA,6BAAA;EACA,sCAAA;AAlDJ;AAmDI;EACE,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,6BAAA;EACA,sCAAA;AAjDN;AAmDI;EACE,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,6BAAA;EACA,sCAAA;AAjDN;AAmDI;EACE,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,6BAAA;EACA,sCAAA;AAjDN;AAmDI;EACE,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,6BAAA;EACA,sCAAA;AAjDN;AAqDE;EACE,kBAAA;EACA,QAAA;AAnDJ;AAsDE;EACE,UAAA;EACA,WAAA;EACA,qBAAA;AApDJ;AAuDE;EACE,UAAA;EACA,WAAA;EACA,cAAA;AArDJ;AAuDI;EACE,WAAA;EACA,cAAA;AArDN;AAyDE;EACE,WC14BI;ED24BJ,eAAA;AAvDJ;AA0DE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAxDJ;AA0DI;EACE,UAAA;EACA,YAAA;AAxDN;;AA6DA;EACE;IACE,UAAA;EA1DF;EA4DA;IACE,UAAA;EA1DF;AACF","sourcesContent":["@import '../../../../../sass/variables';\n\n.checkout {\n  background-color: $white;\n}\n\n.panel {\n  background-color: $white;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n}\n\n.form-control {\n  border: 1px solid $cinza-300;\n}\n\n#form-checkout .has-error input {\n  border-color: $danger;\n  &:focus, &:hover {\n    border: 1px solid $danger;\n  }\n}\n\n.form-control.error {\n    border: 1px solid $danger;\n    animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;\n    transform: translate3d(0, 0, 0);\n    backface-visibility: hidden;\n    perspective: 1000px;\n  }\n\n@keyframes shake {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n\n/*  alterações novas  */\n\n.panel-body-altera {\n  text-align: right;\n}\n\n.panel-body-altera .btn-confirmar {\n  margin-bottom: 5px;\n}\n\n.panel-body-altera .cartoes-cadastrados {\n    padding-bottom: 80px;\n    padding-top: 10px;\n}\n\n.panel-body-altera .cartoes-cadastrados .cartao {\n  padding: 10px;\n  border: 2px solid #00caff;\n  border-radius: 5px;\n  background-color: #fff;\n  text-align: left;\n  height: 46px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  color: hsl(0, 0%, 30%);\n  font-size: 13px;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.5s ease-out;\n}\n\n.panel-body-altera .cartoes-cadastrados .cartao.disabled {\n  background-color: #fcfcfc;\n  border: 2px solid rgba(216, 216, 216, 0.5);\n  color: #8b8b8b;\n  transition: background-color 0.5s ease, border-color 0.5s ease;\n}\n\n.panel-body-altera .cartoes-cadastrados .cartao.disabled:hover {\n  background-color: #fff;\n  border-color: rgba(216, 216, 216, 1);\n}\n\n.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao {\n  background-color: #fcfcfc;\n  border: 2px solid rgba(216, 216, 216, 0.5);\n  ;\n  color: #4379ff;\n  font-family: $fonte-pague-la;\n  font-size: 15px;\n  font-weight: bolder;\n  padding-left: 30px;\n  transition: background-color 0.5s ease, border-color 0.5s ease;\n}\n\n.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao:hover {\n  background-color: #fff;\n  border-color: rgba(216, 216, 216, 1);\n}\n\n.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao span>span {\n  font-size: 19px;\n  line-height: 1;\n}\n\n.panel-body-altera .cartoes-cadastrados .cartao .bandeira-cartao {\n  margin: 0;\n  display: inline-block;\n  vertical-align: middle;\n  height: 26px;\n  width: 66px;\n}\n\n.panel-body-altera .cartoes-cadastrados .cartao .editar-cartao-button {\n  width: 7px;\n  height: 19px;\n  display: inline-block;\n  background-image: url(/assets/icones/menu-edit.svg);\n  background-repeat: no-repeat;\n  padding: 10px;\n  background-position: center;\n}\n\n.panel-body-altera .cartoes-cadastrados .cartao .final-pan strong,\n.cartoes-cadastrados .cartao .validade-cartao strong {\n  font-family: pague-la, \"Open Sans\", sans-serif;\n  font-size: 15px;\n}\n\n.remover-dom {\n  visibility: hidden;\n  opacity: 0;\n  display: none;\n}\n\n.flex {\n  display: flex;\n}\n\n.space-between {\n  justify-content: space-between;\n  align-items: center;\n}\n\nh5 {\n  color: #4d4d4d;\n  font-size: 14px;\n  line-height: inherit;\n}\n\n.info-venda .venda:last-child {\n    margin-bottom: 20px;\n}\n\n.venda .valores {\n    margin-bottom: 5px;\n}\n\n.venda .data-entrada {\n    font-size: 12px;\n    text-align: right;\n}\n\n.venda .data-entrada .valor-data {\n    font-family: pague-la, \"Open Sans\", sans-serif;\n    font-weight: bolder;\n    font-size: 13px;\n}\n\n.venda .valor-entrada{\n  display: block;\n  font-family: pague-la, \"Open Sans\", sans-serif;\n  font-weight: bolder;\n  font-size: 13px;\n  text-align: right;\n}\n\n/* #cartoes-cadastrados, #form-checkout {\n    transition: opacity 0.5s ease;\n} */\n\n@media (min-width: 768px) {\n  .checkout .cls-content .cls-content-lg {\n    width: 700px;\n  }\n}\n\n.menu-remove {\n  background-color: #FFF;\n  width: 100px;\n  height: 35px;\n  border: 1px solid rgba(0,0,0,.15);\n  padding: 7px;\n  text-align: center;\n  border-radius: .25rem;\n  position: relative;\n  top: 12px;\n  left: -78px;\n}\n\n.menu-remove:hover {\n  background-color: #EFEFEF;\n}\n\n@media (min-width: 768px) {\n  .checkout .cls-content .cls-content-lg {\n    width: 700px;\n  }\n}\n\n// @font-face {\n//   font-family: 'pague-la';\n//   src: url('/assets/fonts/pague-la.eot');\n//   src: url('/assets/fonts/pague-la.eot?#iefix') format('embedded-opentype'), url('/assets/fonts/pague-la.woff2') format('woff2'), url('/assets/fonts/pague-la.woff') format('woff'), url('/assets/fonts/pague-la.ttf') format('truetype');\n//   font-weight: 300;\n//   font-style: normal;\n// }\n\n.checkout.cls-container {\n  background-color: #FFFFFF;\n}\n\n.checkout .cls-content {\n  padding-top: 5vh;\n}\n\n.checkout .rodape {\n  margin-top: 30px;\n}\n\n.checkout .rodape p {\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.checkout .panel-content {\n  display: flex;\n}\n\n.checkout p,\n.checkout h4,\n.checkout h5 {\n  display: table;\n}\n\n.mb-clean {\n  margin-bottom: 0;\n}\n\n.checkout .panel-body1 {\n  width: 35%;\n  background-color: #fff;\n  padding: 20px 40px 25px;\n  border-bottom-left-radius: 10px;\n}\n\n.checkout .panel-body1 .total {\n  font-size: 18px;\n  font-family: $fonte-pague-la;\n}\n\n.checkout .panel-body1 p {\n  color: #999999;\n  margin-bottom: 8px;\n}\n\n.checkout .panel-body1 h4 {\n  color: #4379ff;\n  font-family: $fonte-pague-la;\n  font-size: 25px;\n  font-weight: 900;\n  margin-top: 0;\n}\n\n.checkout .texto-destaque {\n  color: #4379ff;\n  font-family: $fonte-pague-la;\n  font-size: 18px;\n  font-weight: 900;\n  margin-top: 0;\n}\n\n.checkout .panel-body1 h5 {\n  margin-top: 15px;\n}\n\n.checkout .panel-body2 {\n  width: 65%;\n  background-color: #fcfcfc;\n  padding: 20px 40px 35px;\n}\n\n@media (min-width: 768px) {\n  .checkout .cartao-credito {\n    width: 100%;\n  }\n}\n\n.checkout .form-control {\n  font-size: 15px;\n  font-weight: bolder;\n}\n\ninput:-moz-placeholder,\ninput::-webkit-input-placeholder,\ninput:-ms-input-placeholder {\n  color: red;\n}\n\n.checkout .panel {\n  border-radius: 10px;\n}\n\n.checkout .panel-heading {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  height: 80px;\n  border-bottom: none;\n}\n\n.pagamento-seguro {\n  text-align: right;\n  position: absolute;\n  right: 40px;\n  top: 20px;\n  color: #ffffff;\n}\n\n.pagamento-seguro p {\n  display: inline-block;\n}\n\n.pagamento-seguro p strong {\n  display: block;\n}\n\n.checkout .panel-heading:after {\n  border-bottom: none;\n}\n\n.checkout .logo-paguela-cinza {\n  margin-bottom: 30px;\n}\n\n.checkout .logo-paguela-cinza svg {\n  height: 30px;\n}\n\n.checkout .panel-heading h3 {\n  color: #fff;\n  letter-spacing: 1px;\n  text-align: left;\n  font-size: 25px;\n  padding-top: 15px;\n  padding-left: 40px;\n  font-family: $fonte-pague-la;\n  font-weight: 100;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  cursor: default;\n}\n\nz .checkout label,\n.registro .pad-all {\n  color: #999999;\n}\n\n.checkout input,\n.registro select {\n  border-radius: 4px;\n  border-color: #d9d9d9;\n}\n\n.checkout input:focus {\n  border-color: #00CAFF;\n}\n\n.checkout .panel-heading {\n  background: rgba(0, 204, 255, 1);\n  background: -moz-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n  background: -webkit-gradient(left bottom, right top, color-stop(0%, rgba(0, 204, 255, 1)), color-stop(70%, rgba(161, 80, 253, 1)), color-stop(100%, rgba(177, 54, 253, 1)));\n  background: -webkit-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n  background: -o-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n  background: -ms-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n  background: linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ccff', endColorstr='#b136fd', GradientType=1);\n}\n\n.mt-20 {\n  margin-top: 20px;\n}\n\n.btn-registrar,\n.btn-primary {\n    position: absolute;\n    bottom: 40px;\n    right: 40px;\n    font-family: $fonte-pague-la;\n    color: $white;\n    font-size: 1.8rem;\n    padding: 7.5px 27px;\n    border-radius: 5px;\n    letter-spacing: 0.8px;\n    background: #22b5ff;\n    background: -moz-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n    background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));\n    background: -webkit-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n    background: -o-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n    background: -ms-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n    background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#22b5ff', endColorstr='#a42cff', GradientType=1);\n    border: none;\n    float: right;\n}\n\n.btn-registrar:active,\n.btn-primary:active,\n.btn-registrar:hover,\n.btn-primary:hover,\n.btn-registrar:focus .btn-primary:focus {\n    color: #fff;\n    background: #22b5ff;\n    background: -moz-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n    background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));\n    background: -webkit-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n    background: -o-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n    background: -ms-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n    background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#22b5ff', endColorstr='#a42cff', GradientType=1);\n}\n\n#reinicia-venda {\n  float: none;\n}\n\n.cadeado {\n  max-width: 35px;\n  display: inline-block;\n  position: relative;\n  top: 2px;\n}\n\n.cadeado svg {\n  height: 30px;\n}\n\n#cartao-error {\n  margin-bottom: 0 !important;\n}\n\n.checkout .form-group {\n  margin-bottom: 15px;\n}\n\n.checkout .form-group .control-label {\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\nimg.logo-cliente {\n  max-width: 165px;\n  max-height: 117px;\n  margin: 10px auto;\n}\n\n.bandeira-cartao {\n  width: 50px;\n    height: 27px;\n    background-size: 100% auto;\n    background-repeat: no-repeat;\n    margin: 7px 0 0 0;\n    opacity: 0;\n    -webkit-transition: opacity .5s ease;\n    transition: opacity .5s ease;\n    right: 8px;\n    top: 3px;\n}\n\n.checkout .has-feedback label~.form-control-feedback {\n  top: 27px;\n  right: 10px;\n}\n\n.master,\n.visa,\n.elo,\n.diners,\n.aura,\n.jcb,\n.hipercard,\n.american-express {\n  opacity: 1;\n}\n\n.default {\n  opacity: 0;\n}\n\n.master {\n  background-image: url('/assets/icones/mastercard.svg');\n}\n\n.hipercard {\n  background-image: url('/assets/icones/hipercard.png');\n}\n\n.visa {\n  background-image: url('/assets/icones/visa.svg');\n}\n\n.american-express {\n  background-image: url('/assets/icones/american-express.svg');\n}\n\n.diners {\n  background-image: url('/assets/icones/diners.svg');\n}\n\n.discover {\n  background-image: url('/assets/icones/discover.svg');\n}\n\n.elo {\n  background-image: url('/assets/icones/elo.svg');\n}\n\n.jcb {\n  background-image: url('/assets/icones/jbc.png');\n}\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1.5),\nonly screen and (min-resolution: 1.5dppx),\n(-webkit-min-device-pixel-ratio: 1.5),\n(min-resolution: 144dpi) {\n  .jcb {\n    background-image: url('/assets/icones/jbc@2x.png');\n  }\n}\n\n.aura {\n  background-image: url('/assets/icones/aura.png');\n}\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1.5),\nonly screen and (min-resolution: 1.5dppx),\n(-webkit-min-device-pixel-ratio: 1.5),\n(min-resolution: 144dpi) {\n  .aura {\n    background-image: url('/assets/icones/aura@2x.png');\n  }\n}\n\n.btn.loading {\n  color: transparent;\n  height: 35px;\n  width: 35px;\n  padding: 0;\n  border-radius: 50%;\n  animation: loadBotao .25s ease, spin .75s linear infinite .25s;\n}\n\n.btn.loading:before {\n  content: \"\";\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n  background-color: #fcfcfc;\n  position: relative;\n  display: block;\n  margin: 1px;\n}\n\n@keyframes loadBotao {\n  from {\n    height: initial;\n    width: initial;\n  }\n  to {\n    height: 35px;\n    width: 35px;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n#nometitular-error {\n  margin-bottom: 40px;\n}\n\n#nometitular-error,\n#cartao-error {\n  color: #eb2521;\n}\n\n@media (max-width: 767px) {\n  .checkout .panel-heading h3 {\n    padding-left: 20px;\n  }\n\n  .checkout .cls-content {\n    padding: 0;\n  }\n\n  .checkout .cls-content .cls-content-lg{\n    width: 100%;\n    box-shadow: none;\n  }\n\n  .checkout .panel-content {\n    display: block;\n  }\n  .logo-cliente {\n    display: block !important;\n  }\n  .info-loja * {\n    display: block !important;\n  }\n  .panel-body2,\n  .panel-body1 {\n    width: 100% !important;\n    text-align: center;\n    padding: 20px !important;\n  }\n  .pagamento-seguro {\n    right: 20px;\n  }\n  .info-pagamento {\n    display: flex;\n    justify-content: space-between;\n  }\n  #nometitular {\n    margin-bottom: 100px;\n  }\n  .checkout .panel-heading {\n    border-radius: 0;\n  }\n  /* .checkout .panel-heading h3 {\n    position: relative;\n    text-align: center;\n    padding: 15px 0 0;\n  }\n  .pagamento-seguro {\n    position: relative;\n    text-align: center;\n    top: 0;\n    right: 0;\n  }\n  .pagamento-seguro p {\n    text-align: right;\n  } */\n  .checkout .panel-body1 p.totais {\n    position: absolute;\n    float: left;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n  .checkout .form-group [for=validadeano].control-label {\n    display: none;\n  }\n}\n\n#resultado-sucesso h3 {\n  display: block;\n  color: #00caff;\n  font-family: $fonte-pague-la;\n  margin-top: 8px;\n}\n\n#resultado-reprovado h3 {\n  display: block;\n  color: #e95753;\n  margin-top: 8px;\n  font-family: $fonte-pague-la;\n}\n\n/*altura SVGS de validação*/\n\n#resultado-sucesso svg,\n#resultado-reprovado svg {\n  height: 75px;\n}\n\n/*animação círculos svgs*/\n\n#resultado-sucesso svg circle,\n#resultado-reprovado svg circle {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n  animation: dash 2.5s ease forwards;\n}\n\n@keyframes dash {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n/* animação somente de sucesso */\n\n#resultado-sucesso svg polyline {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n  animation: dash 3.5s ease forwards;\n  animation-delay: 0.25s;\n}\n\n#resultado-reprovado svg .linha-1 {\n  transform: translate(20px, -20px);\n  opacity: 0;\n  animation: entrando 0.25s ease-in forwards;\n  animation-delay: 0.3s;\n}\n\n#resultado-reprovado svg .linha-2 {\n  transform: translate(-20px, -20px);\n  opacity: 0;\n  animation: entrando 0.25s ease-in forwards;\n  animation-delay: 0.4s;\n}\n\n@keyframes entrando {\n  to {\n    transform: translate(0px, 0px);\n    opacity: 1;\n  }\n}\n\n/* animação reprovado */\n\n#resultado-reprovado svg {\n  animation: shake-reprovado 0.35s ease forwards;\n  animation-delay: 0.6s;\n}\n\n@keyframes shake-reprovado {\n  10%,\n  90% {\n    transform: translate3d( 0, -1px, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d( 0, 2px, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d( 0, -4px, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(0, 4px, 0);\n  }\n}\n\n#resultado-sucesso .bandeira-cartao {\n  position: absolute;\n  top: -5px;\n  right: 0px;\n}\n\n#resultado-sucesso .info-cartao {\n  position: relative;\n  padding-right: 75px;\n}\n\n#resultado-sucesso .fechar {\n  margin-top: 40px;\n}\n\n#resultado-sucesso .info-transacao-aprovada {\n  margin-top: 20px;\n}\n\n#resultado-sucesso .info-transacao-aprovada hr {\n  margin: 10px 0 !important;\n}\n\n#resultado-sucesso .dados-aprovados {\n  display: flex;\n  justify-content: space-between;\n}\n\n.margin-auto {\n  margin: 0 auto;\n}\n\n.mb-30 {\n  margin-bottom: 30px !important;\n}\n\n.mt-30 {\n  margin-top: 30px !important;\n}\n\n/* página 404 */\n\n.pagina-404 #container {\n  background: rgba(0, 247, 255, 1);\n  background: -moz-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n  background: -webkit-gradient(left bottom, right top, color-stop(0%, rgba(0, 247, 255, 1)), color-stop(75%, rgba(170, 0, 255, 1)), color-stop(100%, rgba(170, 0, 255, 1)));\n  background: -webkit-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n  background: -o-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n  background: -ms-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n  background: linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00f7ff', endColorstr='#aa00ff', GradientType=1);\n}\n\n.pagina-404 .btn-confirmar {\n  position: initial;\n}\n\n.pagina-404 .text-main {\n  font-family: pague-la, 'open sans', sans-serif;\n  font-size: 2rem;\n}\n\nh1.error-code {\n  font-family: pague-la, 'open sans', sans-serif;\n  color: #fff;\n}\n\n.checkout-table {\n  width: 100%;\n  margin: 20px 0;\n  tbody {\n    tr {\n      td {\n        color: $cinza-600;\n        border-bottom: 1px solid $cinza-400;\n        padding: 10px 0 5px;\n      }\n    }\n  }\n}\n\n.scheduled-transations {\n  margin-top: 40px;\n}\n\n.modal-checkout {\n  z-index: 10;\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  display: none;\n  top: 0;\n  left: 0;\n  background-color: rgba(#120040, 0.85);\n  font-family: $fonte-pague-la;\n  &.modal-checkout-show {\n    display: block;\n    animation-name: fade;\n    animation-duration: 0.4s;\n    animation-fill-mode: forwards;\n    animation-timing-function: ease-in-out;\n    .icon {\n      animation-name: fade;\n      animation-delay: 0.2s;\n      animation-duration: 0.2s;\n      animation-fill-mode: forwards;\n      animation-timing-function: ease-in-out;\n    }\n    span:first-child {\n      animation-name: fade;\n      animation-delay: 0.4s;\n      animation-duration: 0.5s;\n      animation-fill-mode: forwards;\n      animation-timing-function: ease-in-out;\n    }\n    span:last-child {\n      animation-name: fade;\n      animation-delay: 0.6s;\n      animation-duration: 0.8s;\n      animation-fill-mode: forwards;\n      animation-timing-function: ease-in-out;\n    }\n    button {\n      animation-name: fade;\n      animation-delay: 0.8s;\n      animation-duration: 1.1s;\n      animation-fill-mode: forwards;\n      animation-timing-function: ease-in-out;\n    }\n  }\n\n  div:first-child {\n    position: relative;\n    top: 30%;\n  }\n\n  span {\n    opacity: 0;\n    width: 100%;\n    display: inline-block;\n  }\n\n  .icon {\n    opacity: 0;\n    width: 60px;\n    margin: 0 auto;\n\n    img {\n      width: 100%;\n      margin: 20px 0;\n    }\n  }\n\n  .text {\n    color: $white;\n    font-size: 36px;\n  }\n\n  .button {\n    position: relative;\n    top: 120px;\n    left: 40px;\n    right: 0;\n    width: 200px;\n    margin: 0 auto;\n    transition: 0.5s;\n\n    button {\n      opacity: 0;\n      width: 200px;\n    }\n  }\n}\n\n@keyframes fade {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
